export enum UpdateStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  UPDATE = 'UPDATE',
  UPDATED = 'UPDATED',
  OK = 'OK',
  ERROR = 'ERROR',
  DELETED = 'DELETED',
}
